<mat-vertical-stepper class="stepper-container" [linear]="false" #stepper>
  <mat-step>
    <ng-template matStepLabel>
      <span class="stepper-label"> Select Question Type </span>
    </ng-template>
    <app-quiz-type
      [formGroup]="form"
      [qType]="quizType"
      (emitQuizTypeSelected)="changeQuizType($event)"
    >
    </app-quiz-type>
    <div class="stepper-button-row">
      <button class="secondary-button header-text" mat-button matStepperNext>
        {{ 'Next' | uppercase }}
      </button>
    </div>
  </mat-step>

  <ng-container [ngSwitch]="quizType">
    <ng-container *ngSwitchCase="QTYPE.MULTIPLECHOICE">
      <mat-step [stepControl]="form">
        <ng-template matStepLabel>
          <span class="stepper-label">Add Options</span>
        </ng-template>
        <app-quiz-options
          [form]="form"
          [quiz]="quiz"
          [imageSavePending]="imageSavePending"
          (emitOptionFile)="setFile($event)"
        ></app-quiz-options>
        <div class="row">
          <mat-progress-bar
            mode="indeterminate"
            *ngIf="imageSavePending"
          ></mat-progress-bar>
        </div>
        <div class="stepper-button-row">
          <button
            class="secondary-button header-text"
            mat-button
            matStepperPrevious
            [disabled]="imageSavePending"
          >
            {{ 'Back' | uppercase }}
          </button>
          <button
            class="header-text"
            color="primary"
            mat-raised-button
            matStepperNext
            [disabled]="disabled"
            (click)="saveBlock()"
          >
            {{ 'Save Block' | uppercase }}
          </button>
        </div>
      </mat-step>
    </ng-container>
    <ng-container *ngSwitchCase="QTYPE.FREEANSWER">
      <mat-step [stepControl]="form">
        <ng-template matStepLabel>
          <span class="stepper-label">Write the Answer</span>
        </ng-template>
        <app-quiz-answer [form]="form" [quiz]="quiz"></app-quiz-answer>
        <div class="stepper-button-row">
          <button
            class="secondary-button header-text"
            mat-button
            matStepperPrevious
          >
            {{ 'Back' | uppercase }}
          </button>
          <button
            class="header-text"
            color="primary"
            mat-raised-button
            matStepperNext
            [disabled]="disabled"
            (click)="saveBlock()"
          >
            {{ 'Save Block' | uppercase }}
          </button>
        </div>
      </mat-step>
    </ng-container>
    <ng-container *ngSwitchCase="QTYPE.BOOLEANCHOICE">
      <mat-step [stepControl]="form">
        <ng-template matStepLabel>
          <span class="stepper-label">Select the Answer</span>
        </ng-template>
        <app-quiz-bool [form]="form" [quiz]="quiz"></app-quiz-bool>
        <div class="stepper-button-row">
          <button
            class="secondary-button header-text"
            mat-button
            matStepperPrevious
          >
            {{ 'Back' | uppercase }}
          </button>
          <button
            class="header-text"
            color="primary"
            mat-raised-button
            matStepperNext
            [disabled]="disabled"
            (click)="saveBlock()"
          >
            {{ 'Save Block' | uppercase }}
          </button>
        </div>
      </mat-step>
    </ng-container>
  </ng-container>
</mat-vertical-stepper>
